var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"view-mask",class:{'view-mask-flex' : _vm.flex},style:({zIndex: _vm.zIndex}),on:{"click":_vm.handleClick}},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }